/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TermsAndConditionsRequest } from '../models/TermsAndConditionsRequest';
import type { TermsAndConditionsResponse } from '../models/TermsAndConditionsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TermsAndConditionsRepository {
  /**
   * Get Program Terms And Conditions
   * Get all terms and conditions.
   * @returns TermsAndConditionsResponse Successful Response
   * @throws ApiError
   */
  public static termsAndConditionsGetProgramTermsAndConditions({
    programId,
    authorization,
  }: {
    programId: string,
    authorization?: string,
  }): CancelablePromise<Array<TermsAndConditionsResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/terms-and-conditions/program/{program_id}',
      path: {
        'program_id': programId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Terms And Conditions By Id
   * Get terms and conditions by id.
   * @returns TermsAndConditionsResponse Successful Response
   * @throws ApiError
   */
  public static termsAndConditionsGetTermsAndConditionsById({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<TermsAndConditionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/terms-and-conditions/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Save
   * Creates a new version of terms and conditions.
   * @returns TermsAndConditionsResponse Successful Response
   * @throws ApiError
   */
  public static termsAndConditionsSave({
    requestBody,
    authorization,
  }: {
    requestBody: TermsAndConditionsRequest,
    authorization?: string,
  }): CancelablePromise<TermsAndConditionsResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/terms-and-conditions',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Restore
   * Create a new version of terms and conditions based on a previous one.
   * @returns TermsAndConditionsResponse Successful Response
   * @throws ApiError
   */
  public static termsAndConditionsRestore({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<TermsAndConditionsResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/terms-and-conditions/{id}/restore',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
